// Helper Methods

const getTextContent = (element) => {
	if (
		!element ||
		[...element.childNodes].map((item) => item.nodeName).includes('FORM')
	) {
		return null;
	}

	return element.textContent;
};

/**
 * Gets the form title based on context, trimmed:
 *    Forms in dialog get the ui-dialog title
 *    Forms on page get the widget title
 *
 * If not found, returns empty string.
 *
 * @param {jQuery} form the form as a jquery object
 * @returns {string} the form title, or empty string
 */
const getFormTitle = (form) => {
	const formTitle =
		// get dialog title
		getTextContent(
			form?.closest('.ui-dialog')?.querySelector('.ui-dialog-title')
		) ||
		// get form title
		getTextContent(
			form
				?.closest('[data-widget-id]')
				?.querySelector('h1, .widget-heading')
		) ||
		// title of navigation forms
		getTextContent(
			form?.closest('.nav-fragment')?.previousElementSibling
		) ||
		// get widget title
		getTextContent(form?.closest('[data-widget-id]')?.firstElementChild) ||
		// you get nothing!
		'';

	return formTitle.trim();
};

export default getFormTitle;
